module.exports = __webpack_public_path__ + "img/kele4.f82bcc8b.jpg";